import { render, staticRenderFns } from "./_articleId.vue?vue&type=template&id=87c11bce&"
import script from "./_articleId.vue?vue&type=script&lang=js&"
export * from "./_articleId.vue?vue&type=script&lang=js&"
import style0 from "./_articleId.vue?vue&type=style&index=0&id=87c11bce&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports